import Editor from "react-simple-code-editor"
import { FC, ReactNode } from "react"
import { highlight, languages } from "prismjs"
import "prismjs/themes/prism-okaidia.css"

type Props = {
  code: string
  onValueChange(value: string): void
  language: "javascript" | "html"
}

const CodeEditor: FC<Props> = ({ code, language, onValueChange }) => {
  return (
    <Editor
      value={code}
      onValueChange={(value: string): void => onValueChange(value)}
      highlight={(): ReactNode => highlight(code, languages[language], language)}
      padding={10}
      style={{
        fontFamily: "\"Fira code\", \"Fira Mono\", monospace",
        fontSize: 12,
        background: "#333",
        color: "#fff",
        borderRadius: "5px"
      }}
    />
  )
}

export default CodeEditor
